import { FormChildQuestionDto, FormQuestionDto } from "@green0meter/api-client";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { FC, memo } from "react";
import { useFormContext } from "react-hook-form";

import DatePickerField from "@components/common/DatePickerField";

interface DatePicker {
  parentQuestionCode?: string;
  question: FormQuestionDto | FormChildQuestionDto;
  disabled?: boolean;
}

const DatePicker: FC<DatePicker> = ({ question, disabled, parentQuestionCode }) => {
  const { control } = useFormContext();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePickerField
        label={(question as FormQuestionDto).placeholder || question.name}
        control={control}
        name={
          parentQuestionCode
            ? `${parentQuestionCode}-${question.code}`
            : question.code
        }
        disabled={disabled}
      />
    </LocalizationProvider>
  );
};

export default memo(DatePicker);
